// @ts-strict-ignore
import {setCacheNamespace} from 'common/report/queries/utils/fetch-cache';
import {isBrowserEnv} from 'common/report/util/env';
import {HttpClient} from 'common/util/shared-client';

class PublicClient extends HttpClient {}

let publicClient: PublicClient;
if (isBrowserEnv()) {
  // since api-client is a prime consumer of fetch-cache
  // we ensure fetch-cache is namespaced by user.id before fromFetchCache and updateFetchCache is called
  setCacheNamespace(`user:anonymous`);

  // initialize as window singleton that is shared between bundles
  publicClient = window[`__publicClient`] = window[`__publicClient`] || new PublicClient();
} else {
  // probably in unit test env, module level singleton
  publicClient = new PublicClient();
}

export {publicClient};
